import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  sectionPaper: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(2),
  },
  attachmentItems: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 215,
  },
  whiteInput: {
    backgroundColor: theme.palette.background.paper,
  },
}))

export default styles
